import ProblemasAtivosPorEquipe from '../pages/IndicadoresAps/eSFeAP/PreNatal/ProblemasAtivos/PorEquipe'

import TresIndicadoresPreNatalPorEquipe from '../pages/IndicadoresAps/eSFeAP/PreNatal/TresIndicadoresPreNatal/PorEquipe'

import BuscaAtiva from '../pages/IndicadoresAps/eSFeAP/BuscaAtiva/Index.vue'
import BuscaAtivaPorEquipeAcs from '../pages/IndicadoresAps/eSFeAP/BuscaAtiva/PorEquipeAcs'

import IndicadorCitologico from '../pages/IndicadoresAps/eSFeAP/IndicadorCitologico/IndicadorCitologico'
import IndicadorCitologicoPorEquipeAcs from '../pages/IndicadoresAps/eSFeAP/IndicadorCitologico/PorEquipeAcs'
import IndicadorCitologicoPorProfissional from '../pages/IndicadoresAps/eSFeAP/IndicadorCitologico/PorProfissional'

import IndicadorImunizacao from '../pages/IndicadoresAps/eSFeAP/IndicadorImunizacao/IndicadorImunizacao'
import IndicadorImunizacaoPorEquipeAcs from '../pages/IndicadoresAps/eSFeAP/IndicadorImunizacao/PorEquipeAcs'
import IndicadorImunizacaoPorProfissional from '../pages/IndicadoresAps/eSFeAP/IndicadorImunizacao/PorProfissional'

import PreNatal from '../pages/IndicadoresAps/eSFeAP/PreNatal/Index.vue'
import ConsultasPreNatal from '../pages/IndicadoresAps/eSFeAP/PreNatal/ConsultasPreNatal/ConsultasPreNatal'
import ConsultasPreNatalPorEquipeAcs from '../pages/IndicadoresAps/eSFeAP/PreNatal/ConsultasPreNatal/PorEquipeAcs'
import ConsultasPreNatalPorProfissional from '../pages/IndicadoresAps/eSFeAP/PreNatal/ConsultasPreNatal/PorProfissional'

import ConsultasOdontologicas from '../pages/IndicadoresAps/eSFeAP/PreNatal/ConsultasOdontologicas/ConsultasOdontologicas'
import ConsultasOdontologicasPorEquipeAcs from '../pages/IndicadoresAps/eSFeAP/PreNatal/ConsultasOdontologicas/PorEquipeAcs'
import ConsultasOdontologicasPorProfissional from '../pages/IndicadoresAps/eSFeAP/PreNatal/ConsultasOdontologicas/PorProfissional'

import ExamesHivSifilis from '../pages/IndicadoresAps/eSFeAP/PreNatal/ExamesHivSifilis/ExamesHivSifilis'
import ExamesHivSifilisPorEquipeAcs from '../pages/IndicadoresAps/eSFeAP/PreNatal/ExamesHivSifilis/PorEquipeAcs'
import ExamesHivSifilisPorProfissional from '../pages/IndicadoresAps/eSFeAP/PreNatal/ExamesHivSifilis/PorProfissional'

import DoencasCronicas from '../pages/IndicadoresAps/eSFeAP/DoencasCronicas/Index.vue'
import HemoglobinaGlicada from '../pages/IndicadoresAps/eSFeAP/DoencasCronicas/HemoglobinaGlicada/Index.vue'
import HemoglobinaGlicadaPorEquipeAcs from '../pages/IndicadoresAps/eSFeAP/DoencasCronicas/HemoglobinaGlicada/PorEquipeAcs'
import HemoglobinaGlicadaPorProfissional from '../pages/IndicadoresAps/eSFeAP/DoencasCronicas/HemoglobinaGlicada/PorProfissional'

import AtendimentoHipertensao from '../pages/IndicadoresAps/eSFeAP/DoencasCronicas/AtendimentoHipertensao/Index.vue'
import AtendimentoHipertensaoPorEquipeAcs from '../pages/IndicadoresAps/eSFeAP/DoencasCronicas/AtendimentoHipertensao/PorEquipeAcs'
import AtendimentoHipertensaoPorProfissional from '../pages/IndicadoresAps/eSFeAP/DoencasCronicas/AtendimentoHipertensao/PorProfissional'

import HiperDia from '../pages/IndicadoresAps/eSFeAP/DoencasCronicas/HiperDia/Index.vue'
import HiperDiaPorEquipeAcs from '../pages/IndicadoresAps/eSFeAP/DoencasCronicas/HiperDia/PorEquipeAcs'
import HiperDiaPorProfissional from '../pages/IndicadoresAps/eSFeAP/DoencasCronicas/HiperDia/PorProfissional'

export default [
  {
    path: '/esf-eap',
    component: () => import('@/pages/IndicadoresAps/eSFeAP/Index.vue'),
  },
  {
    path: '/problemas-ativos',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/PreNatal/ProblemasAtivos/Template.vue'
      ),
    children: [
      {
        path: '/problemas-ativos/equipe',
        component: ProblemasAtivosPorEquipe,
      },
    ],
  },
  {
    path: '/busca-ativa',
    component: () =>
      import('@/pages/IndicadoresAps/eSFeAP/BuscaAtiva/Template.vue'),
    children: [
      {
        path: '/busca-ativa',
        component: BuscaAtiva,
      },
      {
        path: '/busca-ativa/equipe/acs',
        component: BuscaAtivaPorEquipeAcs,
      },
    ],
  },
  {
    path: '/indicador-citologico',
    component: () =>
      import('@/pages/IndicadoresAps/eSFeAP/IndicadorCitologico/Template.vue'),
    children: [
      {
        path: '/indicador-citologico',
        component: IndicadorCitologico,
      },
      {
        path: '/indicador-citologico/equipe/acs',
        component: IndicadorCitologicoPorEquipeAcs,
      },
      {
        path: '/indicador-citologico/profissional',
        component: IndicadorCitologicoPorProfissional,
      },
    ],
  },
  {
    path: '/indicador-imunizacao',
    component: () =>
      import('@/pages/IndicadoresAps/eSFeAP/IndicadorImunizacao/Template.vue'),
    children: [
      {
        path: '/indicador-imunizacao',
        component: IndicadorImunizacao,
      },
      {
        path: '/indicador-imunizacao/equipe/acs',
        component: IndicadorImunizacaoPorEquipeAcs,
      },
      {
        path: '/indicador-imunizacao/profissional',
        component: IndicadorImunizacaoPorProfissional,
      },
    ],
  },
  {
    path: '/pre-natal',
    component: PreNatal,
  },
  {
    path: '/consultas-pre-natal',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/PreNatal/ConsultasPreNatal/Template.vue'
      ),
    children: [
      {
        path: '/consultas-pre-natal',
        component: ConsultasPreNatal,
      },
      {
        path: '/consultas-pre-natal/equipe/acs',
        component: ConsultasPreNatalPorEquipeAcs,
      },
      {
        path: '/consultas-pre-natal/profissional',
        component: ConsultasPreNatalPorProfissional,
      },
    ],
  },
  {
    path: '/consultas-odontologicas',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/PreNatal/ConsultasOdontologicas/Template.vue'
      ),
    children: [
      {
        path: '/consultas-odontologicas',
        component: ConsultasOdontologicas,
      },
      {
        path: '/consultas-odontologicas/equipe/acs',
        component: ConsultasOdontologicasPorEquipeAcs,
      },
      {
        path: '/consultas-odontologicas/profissional',
        component: ConsultasOdontologicasPorProfissional,
      },
    ],
  },
  {
    path: '/exames-hiv-sifilis',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/PreNatal/ExamesHivSifilis/Template.vue'
      ),
    children: [
      {
        path: '/exames-hiv-sifilis',
        component: ExamesHivSifilis,
      },
      {
        path: '/exames-hiv-sifilis/equipe/acs',
        component: ExamesHivSifilisPorEquipeAcs,
      },
      {
        path: '/exames-hiv-sifilis/profissional',
        component: ExamesHivSifilisPorProfissional,
      },
    ],
  },
  {
    path: '/doencas-cronicas',
    component: DoencasCronicas,
  },
  {
    path: '/hemoglobina-glicada',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/DoencasCronicas/HemoglobinaGlicada/Template.vue'
      ),
    children: [
      {
        path: '/hemoglobina-glicada',
        component: HemoglobinaGlicada,
      },
      {
        path: '/hemoglobina-glicada/equipe/acs',
        component: HemoglobinaGlicadaPorEquipeAcs,
      },
      {
        path: '/hemoglobina-glicada/profissional',
        component: HemoglobinaGlicadaPorProfissional,
      },
    ],
  },
  {
    path: '/atendimento-hipertensao',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/DoencasCronicas/AtendimentoHipertensao/Template.vue'
      ),
    children: [
      {
        path: '/atendimento-hipertensao',
        component: AtendimentoHipertensao,
      },
      {
        path: '/atendimento-hipertensao/equipe/acs',
        component: AtendimentoHipertensaoPorEquipeAcs,
      },
      {
        path: '/atendimento-hipertensao/profissional',
        component: AtendimentoHipertensaoPorProfissional,
      },
    ],
  },
  {
    path: '/hiper-dia',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/DoencasCronicas/HiperDia/Template.vue'
      ),
    children: [
      {
        path: '/hiper-dia',
        component: HiperDia,
      },
      {
        path: '/hiper-dia/equipe/acs',
        component: HiperDiaPorEquipeAcs,
      },
      {
        path: '/hiper-dia/profissional',
        component: HiperDiaPorProfissional,
      },
    ],
  },
  {
    path: '/tres-indicadores-pre-natal',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/PreNatal/TresIndicadoresPreNatal/Template.vue'
      ),
    children: [
      {
        path: '/tres-indicadores-pre-natal/equipe/acs',
        component: TresIndicadoresPreNatalPorEquipe,
      },
    ],
  },
  {
    path: '/mais-acesso-aps',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/MaisAcessoAps/components/Template.vue'
      ),
    children: [
      {
        path: '/mais-acesso-aps',
        component: () =>
          import('@/pages/IndicadoresAps/eSFeAP/MaisAcessoAps/Index.vue'),
      },
    ],
  },
  {
    path: '/pessoa-idosa',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/PessoaIdosa/components/Template.vue'
      ),
    children: [
      {
        path: '/pessoa-idosa',
        component: () =>
          import('@/pages/IndicadoresAps/eSFeAP/PessoaIdosa/Index.vue'),
      },
    ],
  },
  {
    path: '/saude-da-mulher',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/SaudeDaMulher/components/Template.vue'
      ),
    children: [
      {
        path: '/saude-da-mulher',
        component: () =>
          import('@/pages/IndicadoresAps/eSFeAP/SaudeDaMulher/Index.vue'),
      },
    ],
  },
  {
    path: '/pessoa-hipertensao',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/PessoaHipertensao/components/Template.vue'
      ),
    children: [
      {
        path: '/pessoa-hipertensao',
        component: () =>
          import('@/pages/IndicadoresAps/eSFeAP/PessoaHipertensao/Index.vue'),
      },
    ],
  },
  {
    path: '/pessoa-diabetes',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/PessoaDiabetes/components/Template.vue'
      ),
    children: [
      {
        path: '/pessoa-diabetes',
        component: () =>
          import('@/pages/IndicadoresAps/eSFeAP/PessoaDiabetes/Index.vue'),
      },
    ],
  },
  {
    path: '/desenvolvimento-infantil',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/DesenvolvimentoInfantil/components/Template.vue'
      ),
    children: [
      {
        path: '/desenvolvimento-infantil',
        component: () =>
          import(
            '@/pages/IndicadoresAps/eSFeAP/DesenvolvimentoInfantil/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/gestantes-puerperas',
    component: () =>
      import(
        '@/pages/IndicadoresAps/eSFeAP/GestantesPuerperas/components/Template.vue'
      ),
    children: [
      {
        path: '/gestantes-puerperas',
        component: () =>
          import('@/pages/IndicadoresAps/eSFeAP/GestantesPuerperas/Index.vue'),
      },
    ],
  },
]
